import { useRef, useState } from 'react'
import styled from 'styled-components'

import Page from '@/components/Page'
import { useAppStore } from '@/store/hooks'

import Detail from './components/Detail'
import Summary from './components/Summary'

const StyledPage = styled(Page)`
  &.page-wrapper {
    height: auto;

    > .flex-center {
      flex: 1;
      flex-direction: row;
    }
  }

  &.content {
    padding-top: 0;
    max-width: initial;
    flex: 1;
  }
`

function SpaceNotificatorPage() {
  const storeRef = useRef(useAppStore())
  storeRef.current = useAppStore()

  const [showDetail, setShowDetail] = useState(false)
  const [mode, setMode] = useState<'general' | 'selectors'>('general')

  return (
    <StyledPage>
      <div className="mx-auto -mt-[4px] flex w-full flex-1 justify-center pb-20">
        <div className="w-96">
          <Summary
            onHelp={mode => {
              setShowDetail(true)
              setMode(mode)
            }}
          />
        </div>
        {showDetail && (
          <div className="w-96">
            <Detail onHide={() => setShowDetail(false)} mode={mode} />
          </div>
        )}
      </div>
    </StyledPage>
  )
}

export default SpaceNotificatorPage
